import $ from 'jquery';
import constants from 'Constants.js';

import { View } from 'backbone';
import Immutable from 'immutable';
import _Template from 'designer/layout-editor-content.ejs';
import ThumbnailView from 'designer/ThumbPageListView.js'
import MobileThumbnailView from 'designer/MobileThumbPageListView.js'
import layoutPropertyTabs from 'designer/property-tabs.ejs';
import behaviorPropertyTabs from 'behaviors/property-tabs.ejs';
import _model from 'DesignerModel.js'
import BreadCrumbView from 'BreadCrumbView.js';
import listService      from 'ListService.js';
import viewManagerService from 'ViewManagerService';
import eventBus from 'EventBus.js';
import util from 'util/Util.js';
import _ from 'lodash';
import behaviorHelperService from 'BehaviorHelperService';

class EditorContentView extends View {
    thumbnailView;
    breadCrumbView;

    initialize( opts ) {
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = opts.el; 

        this.events = {
            'click img' : 'updateAttributes',
            'click .rail-header > .open-panel': 'animatePanel',
            'click a': 'checkPropSettingsLabels'
        };

        this.templateMap = Immutable.Map([
            [constants.KIND_LAYOUT, layoutPropertyTabs],
            [constants.KIND_MOBILE, layoutPropertyTabs],
            [constants.KIND_REPORT, layoutPropertyTabs],
            [constants.KIND_BEHAVIORS, behaviorPropertyTabs],
            [constants.KIND_WORKFLOW, behaviorPropertyTabs ]
        ]);
 
        this.propertyTabs = layoutPropertyTabs;
        if (this.model.get('mode')) {       
            this.propertyTabs = this.templateMap.get(this.model.get('mode'));
        }
        
        return this;
    }

    checkPropSettingsLabels(e) {
        let targetPanel = e.target.hash || e.currentTarget.parentElement.id;
        let minWidth = 275;
        let tabContentwidth = 235;
        let innerContainers = 255; 
       if (targetPanel === "#propStyle" || targetPanel.includes("theme-combobox")) {
            let isExpanded = $("#right-rail .rail-header > a.toggle").data("open");
            this.changeLabelStyles(isExpanded);
            if (!listService.selected.size && !listService._isSelectedPage) {
                 minWidth = innerContainers = tabContentwidth = 435;
            }
        }
       
        util.showScrollOnPanel (tabContentwidth, minWidth);
        // PF-5004 Commented as it is rendering the Notify control more than 3 times.
       // eventBus.trigger(constants.RESIZE_PROPERTIES_STYLE_PANEL);
    }


    animatePanel(e) {
        let target = $(e.target);
        let panel = target.data('panel');
        let toggleIcon = target.is('a') ? target.find('i') : target;
        let linkToggle = target.is('a') ? target : target.parent();
        let layoutFrame = $(".layout-frame");
        let isExpanded = linkToggle.data("open");
        let leftContent = $('.left-rail');
        let rightContent = $('.right-rail-content');
        const isLeftPanel = panel === 'left-cell';
        let style = "";

        const collapsedWidth = 50;
        const expandedWidth = 420; 

        let removeClass, addClass, frameWidth;
        let width = 0; 

        if (!isExpanded) {
            width = expandedWidth;
            frameWidth = 640; 

            if (rightContent.css('display') === 'none') {
                rightContent.css('display', 'block');
            }
        }
        else {
            width = collapsedWidth;
            frameWidth = 740;
        }

        let props = util.getPanelIcons(isLeftPanel, isExpanded);

        removeClass = props.removeClass;
        addClass = props.addClass;
        style = props.style; 

        util.setPanelAttrs(isLeftPanel, { width, addClass: props.addClass, 
            removeClass: props.removeClass, isExpanded: !isExpanded});

        util.hideIcons(isLeftPanel ? $('.left-cell') : $('.right-cell'), 50, width);
        util.displayChildren(isLeftPanel ? leftContent.children() : rightContent, style);
        
        toggleIcon
            .removeClass(removeClass)
            .addClass(addClass); 

        layoutFrame.css("min-width", frameWidth);

        let mode = this.model.get("mode");

        if (mode !== 'W' && mode !== "B") {
            this.changeLabelStyles(!isExpanded);
        }

        $('.' + panel).width(width);

        linkToggle.data("open", !isExpanded);
        eventBus.trigger(constants.RESIZE_PROPERTIES_STYLE_PANEL);
    }    

    changeLabelStyles(isExpanded) {
        let factoryKey = listService.propertyTab_Access.model.get("factoryKey");
        let propStyleTab = $("#propStyle"); 
        propStyleTab.removeClass("propStyleTab"); 
               
        if (factoryKey && _.includes(["layout_frame", "reports_frame"], factoryKey)) {            
            let propStyleLabels = propStyleTab.find(".prop-sublabel"); 
            let addClass = "prop-sublabel-collapsed";
            let removeClass = "prop-sublabel-expanded";
                    
            if (isExpanded) {
                addClass = "prop-sublabel-expanded"; 
                removeClass = "prop-sublabel-collapsed";                
            }
                
            propStyleTab.addClass("propStyleTab");
            propStyleLabels.removeClass(removeClass).addClass(addClass);
        }
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name; 
    }

    initThumbnailPane() {
        const attributes = { };
        if (listService.mainKind === constants.KIND_MOBILE) {
            this.thumbnailView = new MobileThumbnailView({ model: new _model( attributes ), el: constants.THUMBNAIL_PANE });
        }
        else {
            this.thumbnailView = new ThumbnailView({ model: new _model( attributes ), el: constants.THUMBNAIL_PANE });
        }
        
        listService.addMainView(constants.KIND_THUMBLIST, this.thumbnailView);
        this.thumbnailView.render();
    }

    initBreadcrumb() {
        this.breadCrumbView = new BreadCrumbView({
            //mode: this.model.get('mode'),
            mode: listService.mainKind,
            el: this.$el.find('.right-breadcrumb')
        });

        viewManagerService.renderBreadcrumbView(this.breadCrumbView, false); 
    }

    initPropertyTabs() {
        $('#property-tabs').html(this.propertyTabs);
    }

    resizeEditor() {

        if(listService.mainKind === constants.KIND_BEHAVIORS){
            $("#activeBehaviors").height(40);
        }

        
        util.setWidthConstants();
        util.makePanelFit();
        let body = $("body");
        const overflowX = body.width() < 1000 ? 'scroll' : 'hidden';

        body.css("overflow-x", overflowX);
        // If we have hidden behaviors, render it now
        if (listService.mainKind === 'B') {
            behaviorHelperService.showHiddenBehaviors();
        }
    }

    updateDocumentation() {
        if(listService.mainKind === constants.KIND_MOBILE){
            const factoryKey = 'mobile_designer_editor';
            util.updateHelpDocumentationLink(factoryKey);
        }
    }

    render() {
        let that = this;
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        viewManagerService.clearPropertyViews();

        this.initThumbnailPane();
        this.initBreadcrumb();
        this.initPropertyTabs();
        this.resizeEditor(); 
        this.delegateEvents(); 
        util.setPanelSize();
        setTimeout(() => {
            util.doPanelResizable();
        });
        
        setTimeout(() => { 
            let rightLinkToggle = $('#right-rail').find(".rail-header > a.toggle").find("i");  
            rightLinkToggle.data("open", false);
            $("#propStyle").addClass("propStyleTab");

            if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
                this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
            }

            $(window).on('resize', this.resizeEditor);
        }, 100);

        this.updateDocumentation();
        return this;
    }

    remove(){
        $(window).off('resize', this.resizeEditor);
        this.undelegateEvents();
        this.off();
        this.thumbnailView.remove();
        this.breadCrumbView.remove();
        super.remove();
    } 
}

export default EditorContentView;
